
namespace RioERP.Shipping {
    export class ShippingProvidersColumns {
        static columnsKey = 'Shipping.ShippingProviders';
    }
}